import { render, staticRenderFns } from "./NewMessagesBadge.vue?vue&type=template&id=30a0679d&scoped=true"
import script from "./NewMessagesBadge.vue?vue&type=script&lang=ts"
export * from "./NewMessagesBadge.vue?vue&type=script&lang=ts"
import style0 from "./NewMessagesBadge.vue?vue&type=style&index=0&id=30a0679d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0679d",
  null
  
)

export default component.exports